import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotlightSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 8,
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "m21 21-4.3-4.3",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgSpotlightSearch;
